export default {
  user: null,
  isLogged: false,
  token: null,
  _id: null,
  unique_id: null,
  email: null,
  name: null,
  countryName: null,
  phone: null,
  countryPhoneCode: null,
  wallet: null,
  overdraft: null,
  picture_url: null,
  pre_time: null,
  lang: 'es',
  admin_phone: '+584127156879',
  admin_email: 'viajes@ridery.app',
  is_active_shipments: null,
  is_active_multi_stops: null,
  is_corporate_master: null,
  is_used_google_maps_service: null,
  is_assist_mode: null,
  must_change_password: false,
  updated_at: null,
  is_allow_credits: null,
  canCreateTrips: false,
  is_corporate_api_partner: null,
  is_allowed_corporate_api_partner: null,
  is_allowed_corporate_shipment_api: null,
  associated_panels: null,
  sales_executive_phone: null,
  sales_executive_country_phone_code: null,
  is_billing_incomplete: null,
  walletExcess: 0,
  walletExcessCurrency: null,
  times_visited_invoice_ad: 0,
  hide_invoice_ad: true,
  is_internal: null,
};
